<template lang="pug">
  .component-parkinglot-action-buttons
    ul.dropdown.menu(data-dropdown-menu='', v-f="", v-if="entity")
      li
        a(href='#Item-1') Action
        ul.menu
          li
            a(@click="edit") Edit
    .dropdown-buttons(v-else-if="!entity && parkingLot")
      .small.button.alert(@click="remove") Delete
</template>

<script>
  import MaggieHelper from '../../../../maggieHelper'
  import ParkingLotEdit from '../../../backoffice/smartedits/ParkingLotEdit'
  import KeplerBackofficeSdk from '../../../../lib/kepler/backoffice'

  export default {
    name: 'ParkingLotActionButtons',
    data() {
      return {
        entity: null,
      }
    },
    created() {
      if (this.parkingLot === null) {
        KeplerBackofficeSdk.parkingLots.select(this.$route.params.id).get((item) => {
          this.entity = item
        })
      }
    },
    methods: {
      remove() {
        this.$confirm('Are you sure?', 'Will be tried a hard delete on all the parking slots and vehicle slots connected', () => {
          KeplerBackofficeSdk.parkingLots.select(this.parkingLot).remove(() => {
            MaggieHelper.notification('Deleted', 'Parking lot and on all the parking slots and vehicle slots connected have been deleted')
          })
        })
      },
      edit() {
        MaggieHelper.openRightPanel({
          component: ParkingLotEdit, props: {
            item: this.entity
          }
        })
      },
    },
    props: {
      parkingLot: {
        default: null
      }
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// ParkingLotActionButtons.vue?5a8fd628